import { DISABLE_NEXT_NAV } from "../actions/types";

export default (disable = true, action) => {
  if (action.type === DISABLE_NEXT_NAV) {
    return action.payload;
  }
  return disable;
};
